import { fromJS } from 'immutable';

export const getErrorMessage = action =>
  fromJS([{ t: Date.now(), msg: Array.isArray(action?.error) ? action.error[0] : action?.error }]);
